const pagePaths = {
  home: "/", catalog: "/inzeraty", listing: "/inzeraty/detail",
  seller: "/uzivatele/profil", authentication: "/session", onboarding: "/profile",
  help: "/napoveda", information: "/informace", listing_form: "/moje/inzeraty/new",
  listing_management: "/moje/inzeraty", watchdogs: "/moje/hlidaci-psi"
}

const interactionEvents = new Set([
  "catalog_filter_submitted", "listing_card_clicked", "contact_started",
  "contact_email_clicked", "contact_phone_clicked", "contact_message_submitted",
  "listing_form_previewed", "listing_form_submitted", "authentication_submitted"
])

const customApiHost = "https://e.makerbazar.cz"

let visit = null
const sessionId = crypto.randomUUID()
let sessionCampaign = null

function settings() {
  const token = document.querySelector('meta[name="posthog-project-token"]')?.content
  const actor = document.querySelector('meta[name="posthog-actor-id"]')?.content
  const page = document.body.dataset.analyticsPage
  if (!token || !Object.hasOwn(pagePaths, page)) return null
  if (navigator.doNotTrack === "1" || navigator.globalPrivacyControl === true) return null

  let pageProperties = {}
  try { pageProperties = JSON.parse(document.body.dataset.analyticsProperties || "{}") } catch { /* ignore invalid markup */ }
  return { token, actor, page, pageProperties }
}

function campaignProperties() {
  if (sessionCampaign) return sessionCampaign

  const params = new URLSearchParams(location.search)
  const clean = key => params.get(key)?.replace(/[^a-zA-Z0-9_.-]/g, "_").slice(0, 64) || undefined
  const referringDomain = (() => {
    try { return document.referrer ? new URL(document.referrer).hostname : undefined } catch { return undefined }
  })()
  sessionCampaign = {
    utm_source: clean("utm_source"), utm_medium: clean("utm_medium"),
    utm_campaign: clean("utm_campaign"), $referring_domain: referringDomain
  }
  return sessionCampaign
}

function capture(event, properties = {}) {
  const config = settings()
  if (!config) return

  const anonymous = !config.actor
  const payload = {
    api_key: config.token,
    event,
    uuid: crypto.randomUUID(),
    distinct_id: anonymous ? "$posthog_cookieless" : config.actor,
    timestamp: new Date().toISOString(),
    properties: {
      "$process_person_profile": false,
      "$geoip_disable": true,
      "$lib_custom_api_host": customApiHost,
      "$current_url": `${location.origin}${pagePaths[config.page]}`,
      "$pathname": pagePaths[config.page],
      "$session_id": sessionId,
      page: config.page,
      logged_in: !anonymous,
      event_source: "browser",
      ...config.pageProperties,
      ...campaignProperties(),
      ...properties
    }
  }
  if (anonymous) {
    payload.properties.$cookieless_mode = true
    payload.properties.$raw_user_agent = navigator.userAgent
    payload.properties.$host = location.hostname
  } else {
    payload.properties.$ip = null
  }

  fetch(`${customApiHost}/i/v0/e/`, {
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    credentials: "omit",
    referrerPolicy: "no-referrer",
    keepalive: true,
    body: JSON.stringify(payload)
  }).catch(() => {})
}

function leavePage() {
  if (!visit) return
  const duration = Math.max(0, (performance.now() - visit.startedAt) / 1000)
  const contentHeight = Math.ceil(visit.maxContentHeight)
  const lastContentY = Math.ceil(visit.lastContentY)
  const maxContentY = Math.ceil(visit.maxContentY)
  const contentPercentage = content => contentHeight <= 1 ? 1 : Math.max(0, Math.min(1, content / contentHeight))
  capture("$pageleave", {
    "$pageview_id": visit.id,
    "$prev_pageview_duration": Math.round(duration * 10) / 10,
    "$prev_pageview_pathname": visit.path,
    "$prev_pageview_last_content_percentage": contentPercentage(lastContentY),
    "$prev_pageview_max_content_percentage": contentPercentage(maxContentY),
    scroll_percentage: visit.maxScroll
  })
  visit = null
}

function updateScrollMetrics() {
  if (!visit) return

  const contentHeight = Math.max(0, document.documentElement.scrollHeight || 0)
  const viewportHeight = document.documentElement.clientHeight || innerHeight
  const content = scrollY + viewportHeight
  visit.lastContentY = content
  visit.maxContentY = Math.max(visit.maxContentY, content)
  visit.maxContentHeight = Math.max(visit.maxContentHeight, contentHeight)

  const height = document.documentElement.scrollHeight - innerHeight
  visit.maxScroll = Math.max(visit.maxScroll, height <= 0 ? 100 : Math.min(100, Math.round(scrollY / height * 100)))
}

document.addEventListener("turbo:load", () => {
  const config = settings()
  if (!config) return

  visit = {
    id: crypto.randomUUID(), startedAt: performance.now(), path: pagePaths[config.page],
    maxScroll: 0, lastContentY: 0, maxContentY: 0, maxContentHeight: 0
  }
  updateScrollMetrics()
  capture("$pageview", { "$pageview_id": visit.id })
  if (config.page === "catalog") capture("catalog_viewed")
  if (config.page === "listing") capture("listing_viewed")
  if (config.page === "listing_form") capture("listing_form_viewed")
})

window.addEventListener("scroll", () => {
  updateScrollMetrics()
}, { passive: true })
window.addEventListener("resize", updateScrollMetrics)

document.addEventListener("turbo:before-render", leavePage)
window.addEventListener("pagehide", leavePage)

document.addEventListener("click", event => {
  const target = event.target.closest("[data-analytics-event]")
  const name = target?.dataset.analyticsEvent
  if (!interactionEvents.has(name)) return
  capture(name, {
    contact_method: target.dataset.analyticsContactMethod,
    listing_id: target.dataset.analyticsListingId,
    position: target.dataset.analyticsPosition ? Number(target.dataset.analyticsPosition) : undefined
  })
}, { capture: true })

document.addEventListener("submit", event => {
  const name = event.target.dataset.analyticsEvent
  if (interactionEvents.has(name)) capture(name)
}, { capture: true })

document.addEventListener("makerbazar:analytics", event => {
  if (interactionEvents.has(event.detail?.event)) capture(event.detail.event)
})
